module.exports = __webpack_public_path__ + "img/favicon-src.89347addfa46146e99804f7a3bc6e5fd.png";